var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "admin-forms-list" },
    [
      _c("loading-box", { attrs: { loading: _vm.loading } }),
      _c("div", { staticClass: "green-divider" }),
      _c("b-table", {
        staticClass: "bv-table",
        attrs: {
          striped: "",
          hover: "",
          items: _vm.formsList,
          fields: _vm.templateFields,
          "selected-variant": "success",
          "th-class": "bv-table-header",
          "current-page": _vm.currentPage,
          "per-page": _vm.perPage,
          filter: _vm.filterMethod === "local" ? _vm.filter : undefined,
          "filter-included-fields": _vm.filterFields,
          "tbody-tr-class": "table-body-centered"
        },
        on: { "row-clicked": _vm.onRowSelected },
        scopedSlots: _vm._u([
          {
            key: "cell(template)",
            fn: function(row) {
              return [
                _vm._v(
                  " " +
                    _vm._s(row.item.template.template_id) +
                    "R" +
                    _vm._s(row.item.template.revision_number) +
                    " "
                )
              ]
            }
          },
          {
            key: "cell(icon)",
            fn: function(row) {
              return [
                row.item.template.icon
                  ? _c("span", [
                      _c("i", {
                        staticClass: "mr-3 fa",
                        class: row.item.template.icon,
                        style: "color: " + row.item.template.color + ";"
                      })
                    ])
                  : _vm._e()
              ]
            }
          },
          {
            key: "cell(actions)",
            fn: function(row) {
              return [
                !row.item.disable_delete
                  ? _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true }
                        }
                      ],
                      staticClass: "row-icon-button-danger",
                      class: _vm.$config.icons.general.remove,
                      attrs: { title: "Delete" },
                      on: {
                        click: function($event) {
                          return _vm.deleteForm(row.item, $event)
                        }
                      }
                    })
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _c("div", { staticClass: "green-divider" }),
      _c("div", { staticClass: "footer" }, [
        _c("div", { staticClass: "table-results" }, [
          _vm._v(" Results: " + _vm._s(_vm.totalRows) + " ")
        ]),
        _c(
          "div",
          { staticClass: "page-bar" },
          [
            _c("b-form-select", {
              staticClass: "page-select",
              attrs: {
                variant: "dark",
                id: "perPageSelect",
                size: "sm",
                options: _vm.pageOptions
              },
              model: {
                value: _vm.perPage,
                callback: function($$v) {
                  _vm.perPage = $$v
                },
                expression: "perPage"
              }
            }),
            _c("b-pagination", {
              staticClass: "page-buttons",
              attrs: {
                variant: "dark",
                "total-rows": _vm.formsList.length,
                "per-page": _vm.perPage,
                align: "fill",
                size: "sm"
              },
              model: {
                value: _vm.currentPage,
                callback: function($$v) {
                  _vm.currentPage = $$v
                },
                expression: "currentPage"
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }